interface Opportunity {
  title: string;
  impact: string;
  action: string;
}

interface OpportunityItemProps {
  opportunity: Opportunity;
  onAction: (prompt: string) => void;
}

export type { Opportunity };

export default function OpportunityItem({ opportunity, onAction }: OpportunityItemProps) {
  return (
    <div className="opportunity-item">
      <div className="opportunity-item-content">
        <span className="opportunity-item-title">{opportunity.title}</span>
        <span className="opportunity-item-impact">{opportunity.impact}</span>
      </div>
      <div className="opportunity-item-actions">
        <button
          className="insight-action-btn"
          onClick={() => onAction(`Show the exact changes needed: ${opportunity.title}`)}
        >
          Apply
        </button>
        <button
          className="insight-action-btn insight-action-secondary"
          onClick={() => onAction(`Break down the data behind: ${opportunity.title}`)}
        >
          Inspect
        </button>
      </div>
    </div>
  );
}
